// Leave Chat is the bystander path (`claimee.id !== account.id`). It must only drop this client's
// tile and unsubscribe. Writing `rejected` here (H3 / `disposeStaleAiSuggestionOnChatClose`) is a
// shared server disposition: the claimee's still-open conversation loses Edit/Send. H3's
// resurrection case (claimee pops a still-claimed tile, `attachChats` re-adds it) is not this
// button — claimees get End Chat, not Leave Chat.
export function leaveOpenClaimedChat<T extends { id: string }>(
    chatId: string,
    selectedChats: T[],
    unsubscribe: (chats: T[]) => void,
): T[] {
    const chat = selectedChats.find(selected => selected.id === chatId)
    if (chat) {
        unsubscribe([chat])
    }
    return selectedChats.filter(selected => selected.id !== chatId)
}
